// utils.ts — small WS-bundle utilities. isJSON moved here from template.js
// (was previously declared ambient via globals.d.ts so router.ts could call it).

function isJSON(str: unknown): boolean {
    try {
        JSON.parse(str as string);
        return true;
    } catch (e) {
        return false;
    }
}

export { isJSON };
